import http from "../http-common";
/* eslint-disable */
class JadwalPraktekDokterService {
  jadwalList(page, itemPerPage, keyword, hari, poli, klinik, dokter) {
    return http.get(
      "/jadwal-praktek-dokter/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&hari=" +
        hari +
        "&poli=" +
        poli +
        "&klinik=" +
        klinik +
        "&dokter=" +
        dokter,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("user_id", data.selectedDokter.id);
    bodyFormData.append("hari", data.selectedHari.code);
    bodyFormData.append("poli_dokter_id", data.selectedPoli.id);
    bodyFormData.append("klinik_type", data.selectedKlinik.code);
    bodyFormData.append("jam_awal", data.jam_awal);
    bodyFormData.append("jam_akhir", data.jam_akhir);

    return http.post("/jadwal-praktek-dokter", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("user_id", data.selectedDokter.id);
    bodyFormData.append("hari", data.selectedHari.code);
    bodyFormData.append("poli_dokter_id", data.selectedPoli.id);
    bodyFormData.append("klinik_type", data.selectedKlinik.code);
    bodyFormData.append("jam_awal", data.jam_awal);
    bodyFormData.append("jam_akhir", data.jam_akhir);

    return http.put(`/jadwal-praktek-dokter/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  delete(id) {
    return http.delete(`/jadwal-praktek-dokter/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new JadwalPraktekDokterService();
